<template>
  <div id="invest-modal">
    <div class="bg-light sticky-top w-100">
      <b-button
        variant="light"
        @click="$emit('closePanel', { closedBy: 'bg' })"
      >
        <close-icon />
      </b-button>
      <div class="wrap py-3 d-inline-block">
        <h6 class="mb-0">Cart</h6>
      </div>
    </div>

    <b-container>
      <div
        class="no-item d-flex text-center justify-content-center align-items-center"
        v-if="cart.cart.length == 0"
      >
        <div class="">
          <div class="empty-cart">
            <span><i class="fas fa-shopping-cart"></i></span>
            <h2 class="mt-3">Your cart is empty!</h2>
          </div>
          <b-button
            class="w-100 mt-4 bg-primary text-light border-primary"
            @click="$emit('closePanel', { closedBy: 'bg' })"
          >
            START SHOPPING
          </b-button>
        </div>
      </div>

      <div v-else>
        <b-row class="row cart-head pb-1 pt-4 mx-1 no-gutters">
          <b-col cols="6">
            <p>Items</p>
          </b-col>
          <b-col cols="3">
            <p>Quantity</p>
          </b-col>
          <b-col cols="3">
            <p>Price</p>
          </b-col>
        </b-row>

        <div
          class="row no-gutters py-3 px-3 cart-items mb-3"
          v-for="(item, index) in cart.cart"
          :key="index"
        >
          <b-col cols="6">
            <div class="d-flex">
              <b-avatar
                rounded="sm"
                :src="item.product.image"
                size="45px"
              ></b-avatar>
              <div class="ml-2 d-flex align-items-center justify-content-center">
                <p class="mb-0">
                  <b>{{ item.product.name }} </b>
                </p>
              </div>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="d-flex aalign-items-center qty">
              <span
                class="badge badge-primary pointer text-light mr-2"
                @click="decreamentCartItem(index)"
              >
                <i class="fas fa-minus"></i>
              </span>
              <p class="mb-0">{{ item.quantity }}</p>
              <span
                class="badge badge-primary pointer text-light ml-2"
                @click="increamentCartItem(index)"
              >
                <i class="fas fa-plus"></i>
              </span>
            </div>
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-center"
            cols="3"
          >
            <p class="mb-0">{{ formatMoney(item.amount) }}</p>
            <i
              class="far fa-times-circle cancel text-primary"
              @click="removeItem(index)"
            ></i>
          </b-col>
        </div>
        <div class="d-flex justify-content-between mt-5 px-3">
          <p class="mt-4">Total</p>

          <h5 class="mt-4">{{ formatMoney(CartItemTotal) }}</h5>
        </div>
        <hr />
        <!--<div class="subscription px-3">
          <p class="mt-4"><b>Subscription Plans</b></p>
          <small class="mb-4">
            Would you like to make the list of orders above as your subscription
            plan
          </small>

          <b-form-group v-slot="{ ariaDescribedby }" class="mt-3">
            <b-form-radio
              v-model="form.subscription"
              size="lg"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="oneoff"
              >No, Thanks</b-form-radio
            >
            <b-form-radio
              size="lg"
              v-model="form.subscription"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="weekly"
              >Weekly Plans</b-form-radio
            >
            <b-form-radio
              size="lg"
              v-model="form.subscription"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="monthly"
              >Monthly Plans</b-form-radio
            >
          </b-form-group>
        </div>-->

        <b-button
          class="w-100 mt-3 bg-primary text-light"
          v-b-toggle.collapse-3
          variant="outline-primaey"
        >
          PROCEED <i class="fas fa-shopping-cart float-right"></i>
        </b-button>
        <b-collapse :visible="proceed" id="collapse-3">
          <p class="mt-4"><b>Delivery Details</b></p>
          <b-form-group
            id="input-group-1"
            label-for="input-1"
            class="mt-4"
            :state="fieldState.fullname"
            :invalid-feedback="formErrors.fullname"
          >
            <b-form-input
              @keyup="validateContact('fullname')"
              v-model="form.address.fullname"
              type="text"
              required
              id="input-1"
              placeholder="Fullname"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label-for="input-1"
            class="mt-4"
            :state="fieldState.phonenumber"
            :invalid-feedback="formErrors.phonenumber"
          >
            <b-form-input
              @keyup="validateContact('phonenumber')"
              v-model="form.address.phonenumber"
              type="text"
              required
              id="input-1"
              placeholder="Phone Number"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label-for="input-1"
            class="mt-4"
            :state="fieldState.googleAddress"
            :invalid-feedback="formErrors.googleAddress"
          >
            <b-form-input
              @keyup="validateContact('googleAddress')"
              v-model="googleAddress"
              type="text"
              required
              id="pac-input"
              placeholder="Please enter your address"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label-for="input-1"
            :state="fieldState.closestLandmark"
            :invalid-feedback="formErrors.closestLandmark"
          >
            <b-form-input
              id="input-1"
              @keyup="validateContact('closestLandmark')"
              v-model="form.address.closestLandmark"
              type="text"
              required
              placeholder="Nearest Busstop"
            ></b-form-input>
          </b-form-group>

          <!--<b-form-group
            id="input-group-1"
            label-for="state"
            :state="fieldState.state"
            :invalid-feedback="formErrors.state"
          >
            <b-form-select
              id="state"
              v-model="form.address.state"
              required
              class="mb-1"
            >
              <template v-slot:first>
                <option value="lagos state">
                  Lagos state
                </option>
              </template>
            </b-form-select>
          </b-form-group>-->

          <b-form-group
            id="input-group-1"
            label-for="city"
          >
            <b-form-select
              id="city"
              v-model="form.address.city"
              @change="getDeliveryCost"
              required
              class="mb-1"
            >
              <template v-slot:first>
                <option value="">Select your city</option>
                <option value="lagos mainland">Lagos Mainland</option>
                <option value="lagos island">Lagos Island</option>
                <option value="abeokuta">Abeokuta</option>
              </template>
            </b-form-select>
          </b-form-group>


          <!--<b-form-group
            id="input-group-1"
            label-for="input-1"
            class="mb-4"
            :state="fieldState.city"
            :invalid-feedback="formErrors.city"
          >
            <b-form-input
              id="input-1"
              @keyup="validateContact('city')"
              v-model="form.address.city"
              type="text"
              required
              placeholder="Enter city"
            ></b-form-input>
          </b-form-group>-->

          <div class="">

            <div class="d-flex justify-content-between mt-2 px-1" v-if="deliveryCost > 0">
              <p class="">Delivery Cost</p>
              <h5 class="">{{ formatMoney(deliveryCost) }}</h5>
            </div>

            <div class="" v-else >
              <b-skeleton animation="fade" width="100%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
            </div>

            <p style="font-size: 12px; font-style: italic;">Delivery usually take between 48 to 72 hours</p>

          </div>
          
          <b-form @input="formInput">
            <b-col cols="12" class="mt-3">
              <b-form-group label="Pay Via">
                <b-form-radio-group
                  id="payment-source"
                  :options="paymentOptions"
                  v-model="paymentType"
                  buttons
                  :disabled="error"
                  button-variant="white"
                  name="radio-btn-outline"
                  class="w-100 custom-radio"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-collapse
              :visible="paymentType == 'card'"
              id="select-card-wrapper"
            >
              <b-col cols="12">
                <b-row>
                  <b-col cols="12" class="mb-4" v-if="paymentType == 'card'">
                    <div class="wrapper py-3">
                      <small>Total Amount</small>
                      <h5 class="mb-0">{{ formatMoney(OrderTotal) }}</h5>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <hr class="mt-0" />
              <b-col cols="12">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-append>
                      <b-button
                        @click="openPaystack"
                        variant="primary"
                        :disabled="submittingPaystack || error || loading"
                        >{{
                          submittingPaystack ? "Paying" : "Pay Now"
                        }}</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-collapse>

            <b-collapse
              :visible="paymentType == 'wallet'"
              id="select-card-wrapper"
            >
              <b-col cols="12">
                <b-row>
                  
                  <b-col cols="12" class="mb-4" v-if="paymentType == 'wallet'">
                    <div class="wrapper py-3">
                      <small>Total Amount</small>
                      <h5 class="mb-0">{{ formatMoney(OrderTotal) }}</h5>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <hr class="mt-0" />
              <b-col cols="12">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-append>
                      <b-button
                        @click="openPaystack"
                        variant="primary"
                        :disabled="submittingPaystack || error || loading"
                        >{{
                          submittingPaystack ? "Paying" : "Pay Now"
                        }}</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-collapse>

            <b-collapse
              :visible="paymentType == 'bank'"
              id="select-card-wrapper"
            >
              <b-col cols="12">
                <b-row>
                  <b-col cols="12">
                    <div class="wrapper bg-light dash-card p-3 mb-4">
                      <h6>
                        Payment Details
                        <b-button
                          size="sm"
                          v-b-modal.getpaymentdetails
                          variant="primary"
                          class="my-2"
                          >How to pay</b-button
                        >
                      </h6>
                      <hr />
                      <b-row>
                        <b-col cols="6">
                          <small>Account Name</small>
                        </b-col>
                        <b-col cols="6">Globarel Limited</b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col cols="6">
                          <small>Account Number</small>
                        </b-col>
                        <b-col cols="6">0251451096</b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col cols="6">
                          <small>Bank</small>
                        </b-col>
                        <b-col cols="6">Guarantee Trust Bank</b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Upload Payment Proof:"
                  :invalid-feedback="formErrors.paymentproof"
                  :state="fieldState.paymentproof"
                >
                  <b-form-file
                    required
                    v-model="form.paymentproof"
                    accept=".jpg, .jpeg, .png, .gif"
                    id="paymentproof"
                    ref
                    :state="fieldState.paymentproof"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <hr />
              <b-col cols="12">
                <label for="state">
                  <h6>Bank</h6>
                </label>
                <b-form-select
                  id="bankcode"
                  v-model="form.bankcode"
                  :options="nigerianBanks"
                  :state="fieldState.bankcode"
                  required
                  class="mb-4"
                >
                  <template v-slot:first>
                    <option :value="null" disabled>
                      -- Select Your Bank --
                    </option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback :state="fieldState.bankcode">
                  {{ formErrors.bankcode }}
                </b-form-invalid-feedback>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Payment Reference:"
                  :invalid-feedback="formErrors.reference"
                  :state="fieldState.reference"
                >
                  <b-form-input
                    id="reference"
                    type="text"
                    v-model="form.reference"
                    :state="fieldState.reference"
                    placeholder="e.g 100003333222"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-button
                  @click="submit()"
                  :disabled="submitting"
                  variant="primary"
                  class="mb-4"
                  >Upload</b-button
                >
              </b-col>
            </b-collapse>
          </b-form>

          <div
            class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
            style="
              top: 0;
              left: 0;
              z-index: 10;
              background-color: rgba(255, 255, 255, 0.7);
            "
            v-if="submittingPaystack || submitting"
          >
            <b-spinner label="Small Spinner"></b-spinner>
          </div>
          <div
            class="wrapper loading-wrapper position-absolute w-100 h-100 top-0 left-0 d-flex align-items-center justify-content-center"
            style="background-color: rgba(255, 255, 255, 0.4); z-index: 10"
            v-if="submitting"
          >
            <b-spinner variant="target-save" label="Spinning"></b-spinner>
          </div>
          <paystack
            :amount="OrderTotal * 100"
            :email="userObj.email"
            :paystackkey="paystackKey"
            :callback="paystackCallback"
            :close="paystackClose"
            :reference="form.reference"
            :embed="false"
          ></paystack>

          <b-modal
            centered
            title="Payment Bank Details"
            id="getpaymentdetails"
            ref="getpaymentdetails"
            ok-only
          >
            <div class="modal-wrap">
              <p class="mb-4">
                To invest using the bank deposit or transfer. You can make a
                deposit to the below stated bank account via bank/mobile banking
                transfer or bank deposit. Upload your payment evidence which
                could be a picture of stamped deposit slip or screenshot of the
                mobile transfer. Obtain your reference number from your bank
              </p>
              <b-row>
                <b-col cols="6">Account Name</b-col>
                <b-col cols="6">Globarel Limited</b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6">Account Number</b-col>
                <b-col cols="6">1020259225</b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="6">Bank</b-col>
                <b-col cols="6">United Bank for Africa</b-col>
              </b-row>
              <hr />
            </div>
          </b-modal>
        </b-collapse>
      </div>
    </b-container>
    <b-button
      class="invisible"
      id="subModal"
      v-b-modal.getpaymentdetails
    ></b-button>
  </div>
</template>

<script>
import paystack from "vue-paystack";
import { mapState } from "vuex";
import { formatMoney } from "@/utils/helpers";
import { TransactionService } from "@/services";
import nigerianBanks from "@/utils/nigerianBanks";
// import  initMap from "../../../../plugins/googleMap";
import { validateRequired, checkFormErrors } from "@/utils/validators";

export default {
  name: "invest-modal",
  props: {
    product: null,
  },
  metaInfo() {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyB3v8I5clqgAZlo9IYUaIuAW2Dl6ERYdYI&libraries=places&v=weekly`,
          async: true,
          defer: true,
          callback: () => this.initMap(),
        },
      ],
    };
  },

  mounted() {
    this.checkScreen();
  },
  data() {
    return {
      googleAddress: "",
      deliveryCost: "",
      form: {
        cart: [],
        address: {
          city: "",
          state: "",
          fullname: "",
          googleddress: "",
          closestLandmark: "",
        },
        subscription: "oneoff",
        reference: "",
        packageid: 0,
        paymentproof: null,
        bankcode: null,
        requesttype: null,
      },

      proceed: false,
      addtocart: false,
      farmPrice: 0,
      ServiceCost: 0,
      selected: null,

      error: true,
      loading: false,
      submitting: false,
      submittingPaystack: false,
      amountPaystack: 0,
      nigerianBanks: nigerianBanks,
      paymentType: null,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      paymentOptions: [],
      formErrors: {},
    };
  },
  components: {
    paystack,
  },
  computed: {
    ...mapState(["userObj", "cart"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    },

    CartItemTotal() {
      let total = 0;
      let cart = this.cart.cart;

      cart.forEach((elm) => {
        total += Number(elm.amount);
      });

      return total;
    },

    OrderTotal (){
      return Number(this.CartItemTotal + this.deliveryCost);
    },

    roi() {
      if (!this.product) return formatMoney(0);
      const averagereturns = (this.product.minroi + this.product.maxroi) / 2;
      return formatMoney(
        this.ServiceCost + (this.ServiceCost * averagereturns) / 100
      );
    },
    state() {
      return this.farmPackage !== "" ? true : false;
    },
    validFeedback() {
      return this.state === true ? "Thank you" : "";
    },
    invalidFeedback() {
      if (this.farmPackage !== "") {
        return "";
      } else {
        return "Please select farm package";
      }
    },
  },

  methods: {
    formatMoney,
    initMap() {
      const input = document.getElementById("pac-input");
      var options = {
        componentRestrictions: { country: "ng" },
      };
      const autocomplete = new window.google.maps.places.Autocomplete(
        input,
        options
      );

      autocomplete.setFields([
        "address_components",
        "geometry",
        "icon",
        "name",
      ]);
      const infowindow = new window.google.maps.InfoWindow();
      const infowindowContent = document.getElementById("infowindow-content");
      infowindow.setContent(infowindowContent);
      const marker = new window.google.maps.Marker({
        anchorPoint: new window.google.maps.Point(0, -29),
      });
      autocomplete.addListener("place_changed", async () => {
        infowindow.close();
        marker.setVisible(false);
        const place = autocomplete.getPlace();
        this.form.address.googleAddress = place;

        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name + "'");
          return;
        }

        // If the place has a geometry, then present it on a map.
      });
    },
    checkScreen() {
      let me = window.innerWidth;
      if (me < 490) {
        this.paymentOptions.push(
          { text: "Card", value: "card" },
          { text: "Wallet", value: "wallet" },
          { text: "Bank", value: "bank" }
        );
      } else {
        this.paymentOptions.push(
          { text: "Card", value: "card" },
          { text: "Wallet", value: "wallet" },
          { text: "Bank Transfer/ Deposit", value: "bank" }
        );
      }
    },
    generateCost() {
      this.farmPackage.find((item) => {
        if (item.text.toLowerCase() == this.form.farmPackage.toLowerCase()) {
          this.farmPrice = item.amount * this.form.units;
          this.ServiceCost = this.product.amountperplot * this.form.units;
          this.amountPaystack = this.farmPrice + this.ServiceCost;
        }
      });
    },

   async  getDeliveryCost(){

     if(this.form.address.city !== "") {

       await this.extractCartItem()
       let city = this.form.address.city;
       let cart =  this.cart.cart

        const  data  = await TransactionService.getDeliveryCharge({ cart, city });

        this.deliveryCost = data.deliverycost
        return data;

     }

    },

    removeItem(idx) {
      this.$store.dispatch("removeItem", idx);
    },

    increamentCartItem(idx) {
      this.$store.dispatch("increaseQty", idx);
    },

    decreamentCartItem(idx) {
      if (this.cart.cart[idx].quantity > 1) {
        this.$store.dispatch("reduceQty", idx);
      }
    },

    extractCartItem() {
      let cartItems = this.cart.cart,
        individualItem = {};

      cartItems.forEach((elm) => {
        individualItem.quantity = elm.quantity;
        individualItem.edibleid = elm.product.id;

        this.form.cart.push(individualItem);
      });
      return true
    },

    validateContact(elm) {
      this.formErrors = {};

      // let me = document.getElementById('subModal');
      // me.click()
      // this.$bvModal.show('subscription-modal');

      if (this.form.address.fullname.length < 1 && elm == "fullname") {
        this.formErrors = { fullname: "Please input fullname" };
        this.error = true;
        return;
      }
      if (this.googleAddress.length < 1 && elm == "googleAddress") {
        this.formErrors = { googleAddress: "Please input your address" };
        this.error = true;
        return;
      }
      if (
        this.form.address.closestLandmark.length < 1 &&
        elm == "closestLandmark"
      ) {
        this.formErrors = {
          closestLandmark: "Please input address nearest busstop",
        };
        this.error = true;
        return;
      }
      if (this.form.address.state.length < 1 && elm == "state") {
        this.formErrors = { state: "Please input your state" };
        this.error = true;
        return;
      }
      if (this.form.address.city.length < 1 && elm == "city") {
        this.formErrors = { city: "Please input your city" };
        this.error = true;
        return;
      }

      this.error = false;
    },

    async openPaystack(event) {
      event.preventDefault();
      // this.extractCartItem();
      //console.log(this.cart);
      // return ''
      this.submittingPaystack = true;
      try {
        const { reference } = await TransactionService.initiatePayments();
        this.form.reference = reference;
        if (this.paymentType == "card") {
          const btn = document.querySelector(".payButton");
          btn.click();
        } else {
          this.paystackCallback();
        }
      } catch (err) {
        this.submittingPaystack = false;
      }
    },
    async paystackCallback() {
      // const { reference } = response;

      this.submittingPaystack = true;
      try {
        this.paymentType == "card"
          ? (this.paymentType = "online_payment")
          : this.paymentType;

        const { message } = await TransactionService.orderProducts({
          reference: this.form.reference,
          cart: this.cart.cart,
          address: this.form.address,
          paymentmethod: this.paymentType,
          subscriptiontype: this.form.subscription,
        });

        this.$store.dispatch("toast", {
          message,
        });

        this.$store.dispatch("clearCart");
        this.submittingPaystack = false;
        this.$emit("closePanel", true);

        /**setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);**/
      } catch (err) {
        this.submittingPaystack = false;
      }
    },

    paystackClose() {},

    async submit() {
      // event.preventDefault();
      try {
        this.submitting = true;
        this.validateForm();

        // this.processUpload();
        const { message } = await TransactionService.ediblesManualPayment({
          reference: this.form.reference,
          paymentproof: this.form.paymentproof,
          bankcode: this.form.bankcode,
          cart: this.cart.cart,
          address: this.form.address,
          paymentmethod: this.paymentType,
          subscriptiontype: this.form.subscription,
        });
        this.$store.dispatch("toast", {
          message,
        });

        this.$store.dispatch("clearCart");
        this.$emit("closePanel", true);
      } catch (err) {
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const { reference, paymentproof, bankcode } = this.form;
      let { errors, valid } = validateRequired({
        reference,
        paymentproof,
        bankcode,
      });

      if (
        !errors.paymentproof &&
        paymentproof &&
        !["image/jpeg", "image/jpg", "image/png"].includes(
          this.form.paymentproof.type
        )
      ) {
        errors.paymentproof = "Only picture is allowed i.e jpeg, jpg, png";
        valid = false;
      }

      if (
        !errors.paymentproof &&
        paymentproof &&
        this.form.paymentproof.size > 20 * 1024 * 1024
      ) {
        errors.paymentproof = "File size is too large (20MB Maximum)";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    validateNoDecimals(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    validateNoDecimalsOnPaste() {
      this.form.units = this.form.units.replace(/[^0-9]+/g, "");
      if (this.form.units > 0)
        this.amountPaystack = this.form.units * this.product.amountperplot;
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    getBG(slug) {
      if (slug == "crowd-funding") {
        return "https://images.pexels.com/photos/681335/pexels-photo-681335.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
      } else {
        return "https://images.pexels.com/photos/87223/pexels-photo-87223.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
      }
    },
  },
};
</script>

<style scoped>
.map-container {
  width: 400px;
  height: 400px;
  margin-left: 400px;
}
#map {
  height: 100%;
  /* width: 400px; */
}
.pay-btn {
  margin-top: -35px;
}
.cart-items {
  background: #fff;
  /* box-shadow: 0 0 3px #ccc; */
  box-shadow: 2px 2.8px 2.2px rgba(128, 128, 128, 0.048),
    2px 6.7px 5.3px rgba(128, 128, 128, 0.048),
    0 12.5px 10px rgba(128, 128, 128, 0.048),
    0 22.3px 37.9px rgba(128, 128, 128, 0.048),
    0 41.8px 53.4px rgba(128, 128, 128, 0.048),
    0 100px 180px rgba(128, 128, 128, 0.055);
}

.qty {
  margin-top: 12px;
}

.option-drop {
  padding: 2px 10px !important ;
  height: 45px;
  width: 250px;
}
.moneyTag {
  padding: 15px 10px;
  columns: #000;
  background: #ebebeb;
  font-size: 17px !important;
}

.pointer.badge {
  cursor: pointer;
  font-size: 21px;
  font-weight: bold;
  padding: 1px 6px;
}

.pointer.badge i {
  font-size: 14px;
}

.grams {
  margin-top: -4px !important;
}

.no-item {
  /* opacity: 0.1; */
  height: 80vh;
}

.empty-cart {
  opacity: 0.1;
}

.no-item span i {
  font-size: 150px;
}

.cancel {
  position: absolute;
  top: -20px;
  right: -20px;
  font-size: 23px;
  cursor: pointer;
  transition: 0.4s ease-in-out;
}

.cancel:hover {
  color: red !important;
}
</style>
